import { Exclude, Expose } from 'class-transformer';
import { IsEmail, IsNotEmpty } from 'class-validator';

@Exclude()
export class ProfileDTO {
  @Expose()
  @IsEmail(
    {},
    {
      message: 'Email address is required'
    }
  )
  email: string;

  @Expose()
  @IsNotEmpty({
    message: 'First name is required'
  })
  firstName: string;

  @Expose()
  lastName: string;

  @Expose()
  pushNotificationEmail: boolean;

  @Expose()
  password: string;
}
